import { render, staticRenderFns } from "./OES-category-widget.vue?vue&type=template&id=be05d5c6"
import script from "./OES-category-widget.vue?vue&type=script&lang=js"
export * from "./OES-category-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports